import { ASHLEY_PROMPTS } from "../../speech/ashleyPrompts";

/**
 * @param {string[]} preconditions
 * @param {{ activeSession: object | null, breakActive: boolean }} context
 */
export function evaluatePreconditions(preconditions = [], context = {}) {
  const { activeSession, breakActive } = context;

  for (const precondition of preconditions) {
    switch (precondition) {
      case "active_session":
        if (!activeSession) {
          return {
            ok: false,
            code: "no_active_session",
            message: ASHLEY_PROMPTS.NO_ACTIVE_SESSION,
          };
        }
        break;
      case "no_active_session":
        if (activeSession) {
          return {
            ok: false,
            code: "active_session_exists",
            message: ASHLEY_PROMPTS.NO_ACTIVE_SESSION,
          };
        }
        break;
      case "break_inactive":
        if (!activeSession) {
          return {
            ok: false,
            code: "no_active_session",
            message: ASHLEY_PROMPTS.NO_ACTIVE_SESSION,
          };
        }
        if (breakActive) {
          return {
            ok: false,
            code: "already_on_break",
            message: ASHLEY_PROMPTS.ALREADY_ON_BREAK,
          };
        }
        break;
      case "break_active":
        if (!activeSession) {
          return {
            ok: false,
            code: "no_active_session",
            message: ASHLEY_PROMPTS.NO_ACTIVE_SESSION,
          };
        }
        if (!breakActive) {
          return {
            ok: false,
            code: "not_on_break",
            message: ASHLEY_PROMPTS.NOT_ON_BREAK,
          };
        }
        break;
      default:
        break;
    }
  }

  return { ok: true };
}
